import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
// import GoogleIcon from "../../assets/Icons/GoogleIcon";

import { FcGoogle } from "react-icons/fc";
import { BsApple } from "react-icons/bs";
import { ImFacebook } from "react-icons/im";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import { useDispatch } from "react-redux";
import { loginRedux } from "../../features/userSlice";
import { useMutation } from "@tanstack/react-query";
import Logo from "../../components/Logo";
import useWindowSize from "../../hooks/useWindowSize";
import ForgotPasseordModel from "../../components/ForgotPasswordModel";
import { login, verifyClerkUser } from "../../hooks/api/useAuth";
import { tailChase } from "ldrs";
import { SignInButton, useAuth, useUser } from "@clerk/clerk-react";
import { toast } from "sonner";

tailChase.register();

function Login() {
  const [showModal, setShowModal] = useState(false);
  const [showpass, setShowPass] = useState({
    password: "",
    showPasssWord: false,
  });
  const size = useWindowSize();
  const navigate = useNavigate();
  const { sessionId } = useAuth();
  const { user } = useUser();

  useEffect(() => {
    const handleRegister = async () => {
      try {
        // const token = await getToken();
        if (!user) {
          return;
        }
        if (sessionId) {
          verifyUser(sessionId);
        }
      } catch (error) {
        toast.error("Failed to authenticate user, please try again");
      }
    };

    handleRegister();
  }, [navigate,sessionId, user]);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const dispatch = useDispatch();
  const {
    data,
    isSuccess: loginSuccess,
    error,
    isPending,
    mutate: loginFn,
  } = useMutation({
    mutationFn: login,
  });

  const {
    data: userData,
    isSuccess: verifySuccess,
    error: verifyError,
    isPending: isVerifying,
    mutate: verifyUser,
  } = useMutation({
    mutationFn: verifyClerkUser,
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    loginFn({ email, password });
  };

  useEffect(() => {
    if (loginSuccess) {
      dispatch(
        loginRedux({
          email: data.email,
          loggedIn: true,
        })
      );
      toast.success("Logged in successfully");
      navigate("/");
    }
  }, [loginSuccess]);

  useEffect(() => {
    if (verifySuccess) {
      dispatch(
        loginRedux({
          email: userData.email,
          loggedIn: true,
        })
      );
      toast.success("Logged in successfully");
      navigate("/");
    }
  }, [verifySuccess]);

  const handleOpenModal = (e) => {
    e.preventDefault();
    if (size.width >= 768) {
      // Assuming 768px as the breakpoint for large screens
      navigate("/forgotpassword");
    } else {
      setShowModal(true);
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handlepassword = () => {
    setShowPass({ ...showpass, showPasssWord: !showpass.showPasssWord });
  };

  return (
    <div className="h-screen  dark:bg-black bg-white  overflow-hidden">
      <div className="grid place-content-center ">
        <div className="sm:flex h-full py-10 justify-center items-center sm:space-x-10  ">
          <div className="mr-[50px] mt-2 font-bold hidden md:block">
            <Logo />
            <div className=" ">
              <div className="text-[76px] mt-20 font-sans hidden md:block welcomeScreenTextShadow">
                <h1 className="text-[#2A71E8] text-[70px] font-sans">Lets</h1>
                <h1 className="flex space-x-2 text-[#2A71E8] text-[70px] font-sans">
                  Get<span className="ml-3 text-[#be2117]">Started...</span>
                </h1>
              </div>
            </div>
            <button className="bg-gradient-to-b from-[#BE2117] to-[#09062C] rounded-[20px] p-4 px-11 text-white mt-5 w-[240px]">
              TRANSLATE
            </button>
          </div>
          <div className="flex items-center justify-center  ">
            <div className="sm:shadow-xl sm:bg-[#f4f4f4]  dark:bg-[#33333347] overflow-hidden p-5 rounded-[20px] sm:w-[350px] mt-5 mb-3 items-center px-5">
              <div className="pb-10 flex justify-center sm:hidden">
                <img
                  src="https://uibfs.s3.eu-north-1.amazonaws.com/logo.png"
                  alt=""
                  className="w-20 h-20"
                />
              </div>
              <div className="text-center">
                <h1 className="font-bold text-[#3a3856] text-[20px] hidden md:block dark:text-white">
                  LOGIN
                </h1>
              </div>
              <form className="sm:space-y-2 space-y-6" onSubmit={handleSubmit}>
                <div className="">
                  <label
                    className="font-bold text-[14px] font-sans dark:text-[#6A6A6A]
"
                  >
                    Email address or username
                  </label>
                  <div className="border p-2 rounded-[20px] w-full border-[#8a8a8a] flex items-center px-2">
                    <input
                      className="bg-transparent rounded-full sm:h-[30px] h-[50px] p-2 w-full  dark:text-[#6A6A6A] focus:outline-none "
                      type="text"
                      placeholder="Email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </div>
                </div>
                <div className="">
                  <label className="font-bold text-[14px] font-sans dark:text-[#6A6A6A]">
                    Password
                  </label>
                  <div className="border p-2 rounded-[20px] w-full border-[#8a8a8a] flex items-center px-2">
                    <input
                      className="bg-transparent rounded-full sm:h-[30px] h-[50px] p-2 w-full dark:text-[#6A6A6A] focus:outline-none "
                      type={showpass.showPasssWord ? "text" : "password"}
                      placeholder="Password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
{showpass.showPasssWord ? (
                      <AiOutlineEyeInvisible
                        className="w-6 h-6 cursor-pointer"
                        onClick={handlepassword}
                      />
                    ) : (
                      <AiOutlineEye
                        className="w-6 h-6 cursor-pointer"
                        onClick={handlepassword}
                      />
                    )}
                  </div>
                </div>
                {error && (
                  <div className="text-red-500 text-center text-sm mb-2">
                    {error.message}
                  </div>
                )}

                <div className="text-center">
                  <button
                    className="text-[20px] font-bold text-sm text-blue-white font-sans p-2 mt-1 dark:text-white text-black"
                    onClick={handleOpenModal}
                  >
                    Forgot Password?
                  </button>
                </div>

                <button
                  className="bg-[#2A71E8] w-full py-3 mt-5 text-white font-bold px-4 border rounded-[20px] focus:outline-none focus:shadow-outline"
                  type="submit"
                  disabled={isPending}
                >
                  {isPending || isVerifying ? (
                    <l-tail-chase
                      size="25"
                      speed="1.75"
                      color="black"
                    ></l-tail-chase>
                  ) : (
                    "Log in"
                  )}
                </button>
                <ForgotPasseordModel
                  showModal={showModal}
                  onClose={handleCloseModal}
                />
              </form>
              <div className="flex items-center justify-center mt-8">
                <div className="border-t border-black w-[130px]"></div>
                <span className="px-2 text-sm text-black font-bold dark:text-white ">
                  OR
                </span>
                <div className="border-t border-black w-[130px]"></div>
              </div>

              <SignInButton navigate={(to) => navigate("/")}>
                <div className="flex cursor-pointer space-x-4 justify-center cursor-pointer mt-8">
                  <div class="rounded-full h-10 w-10  py-1 ">
                    <FcGoogle className="w-7 h-7" />
                  </div>
                  <div class="rounded-full  w-10 h-10  bg-[#3C5A99] flex items-center justify-center  ">
                    <ImFacebook color="white" className="w-7 h-7 " />
                  </div>
                  <div className="rounded-full h-10 w-10 bg-[#999999] flex items-center justify-center">
                    <BsApple color="white" className="w-7 h-17" />
                  </div>
                </div>
              </SignInButton>
              {/* <SignInButton>
                  <div className="rounded-full h-[50px] w-[50px] flex items-center justify-center">
                  <FaceBookicon />
                  </div>
                </SignInButton>
                <SignInButton>
                  <div className="rounded-full h-[50px] w-[50px] flex items-center justify-center">
                  <AppleIcon />
                  </div>
                </SignInButton> */}

              {/* <div className="rounded-full h-[50px] w-[50px] bg-[#3C5A99] flex items-center justify-center">
                  <FaceBookicon />
                </div>
                <div className="rounded-full h-[50px] w-[50px] bg-[#999999] flex items-center justify-center">
                  <AppleIcon />
                </div> */}

              <div className="text-center cursor-pointer flex mt-9 text-[14px] font-sans font-bold dark:text-white">
                Don't Have an account? <Link to="/register">Sign Up here</Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
